import { render, staticRenderFns } from "./SignAttachments.vue?vue&type=template&id=fd2d86a2&"
import script from "./SignAttachments.vue?vue&type=script&lang=js&"
export * from "./SignAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports